import axios from 'axios';
import jQuery from 'jquery';
import lodash from 'lodash';
import Vue from 'vue';
import Media from 'vue-media';
import StudiosMap from '../components/StudiosMap';

import Spaces from '../enums/Spaces';
import SpaceTypes from '../enums/SpaceTypes';
import Constants from '../enums/Constants';

require('./polyfill');

// Inject lib in window
window._ = lodash;
window.jQuery = jQuery;
window.$ = jQuery;
window.axios = axios;
window.Vue = Vue;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// VUE.JS Components
Vue.component('media', Media);
Vue.component('studios-map', StudiosMap);

Vue.prototype.$enums = { Spaces, SpaceTypes, Constants };

export const app = new Vue({
  el: '#app',
});
